import React, { useEffect } from 'react'
import Gallery from 'react-grid-gallery'
import map from 'lodash/map'

const GalleryArray = ({ photos }) => {
  return (
    <Gallery
      images={photos}
      enableImageSelection={false}
    />
  )
}
export default GalleryArray



// WEBPACK FOOTER //
// ./src/App/component/ConfirmOrder/GalleryArray.jsx